// routes
import {PATH_CLIENT, PATH_MANAGEMENT, PATH_ADMIN } from '../../routes/paths';
// components
import SvgIconStyle from '../../components/SvgIconStyle';
// ----------------------------------------------------------------------

const getIcon = (name) => (
  <SvgIconStyle
    src={`/static/icons/navbar/${name}.svg`}
    sx={{ width: 20, height: 20 }}
  />
);

const ICONS = {
  create_client: getIcon('ic_admin'),
  client_account: getIcon('ic_bag'),
  logs: getIcon('ic_logs'),
  audit: getIcon('ic_manage'),
};
const sidebarConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: 'general',
    items: [
      {
        title: 'Manage',
        href: PATH_MANAGEMENT.general.cadence,
        icon: ICONS.audit,
        key: 'manage',
        items: [
          {
            title: 'Leads',
            href: PATH_MANAGEMENT.general.lead_search,
            icon: ICONS.audit,
            key: 'lead_search',
            level: 1
          },
          {
            title: 'Endpoints',
            href: PATH_MANAGEMENT.general.endpoints,
            icon: ICONS.audit,
            key: 'endpoints',
            level: 2,
            open: true
          },
          {
            title: 'Cadences',
            href: PATH_MANAGEMENT.general.cadence,
            icon: ICONS.audit,
            key: 'management',
            level: 3,
            open: true
          },
        ]
      },
      {
        title: 'Configure',
        key: 'client',
        href: PATH_CLIENT.integration.client,
        icon: ICONS.client_account
      },
      {
        title: 'Admin',
        icon: ICONS.create_client,
        href: PATH_ADMIN.root,
        key: 'admin',
        hide: true,
        items: [
          {
            title: 'Teams',
            href: PATH_ADMIN.teams.teams,
            icon: ICONS.audit,
            key: 'teams',
            level: 1
          },
          {
            title: 'Users',
            href: PATH_ADMIN.users.users,
            icon: ICONS.audit,
            key: 'users',
            level: 2
          },
          {
            title: 'System Settings',
            href: PATH_ADMIN.settings.settings,
            icon: ICONS.audit,
            key: 'setting',
            level: 2
          },
          {
            title: 'Data Redaction',
            href: PATH_ADMIN.data_redaction.data_redaction,
            icon: ICONS.audit,
            key: 'data_redaction',
            level: 2
          },
        ]
      }
    ]
  },

];

export default sidebarConfig;
